export function useSelUser(multiple, selUserRecords) {
  //已经选择的用户信息
  const alreadySelUsers: any = ref([]);
  //最大选则数量
  const multipleCount = ref(1);

  //是否可以多选，最多可以选择1500
  if (unref(multiple) === true || unref(multiple) === "true") {
    multipleCount.value = 1500;
  }
  //初始化 已选用户数据
  if (unref(selUserRecords) && unref(selUserRecords).length > 0) {
    unref(selUserRecords).forEach((itemDb) => {
      unref(alreadySelUsers).push(unref(itemDb));
    });
  }

  watch(selUserRecords, () => {
    if (unref(selUserRecords) && unref(selUserRecords).length > 0) {
      alreadySelUsers.value = unref(selUserRecords).map(item => {
        return {
          ...item
        }
      })
    }
  })

  /**
   * 选中记录
   * @param item
   */
  const selRecordByTrue = function (item) {
    //如果是单选 则需要把以前选中的记录取消掉
    if (unref(multipleCount) === 1) {
      unref(alreadySelUsers).forEach((itemDb) => {
        unref(itemDb).check = false;
      });
      unref(alreadySelUsers).splice(0, 1600);
    }
    //如果长度没有超过限制
    if (unref(alreadySelUsers).length <= unref(multipleCount)) {
      unref(alreadySelUsers).push(unref(item));
    }
  };

  /**
   * 取消选中
   */
  const selRecordByFalse = function (item) {
    let delIndex = -1;
    unref(alreadySelUsers).forEach((itemDb, selIndex) => {
      if (itemDb.id === item.id) {
        delIndex = selIndex;
      }
    });
    if (delIndex >= 0) {
      unref(alreadySelUsers).splice(delIndex, 1);
    }
  };
  /**
   * 选择记录
   */
  const selItemRecord = function ({ item }) {
    console.log("item", item);

    //表示选择记录
    if (unref(item).check) {
      selRecordByTrue(unref(item));
    } else {
      //表示取消记录
      selRecordByFalse(unref(item));
    }
  };

  /**
   * 删除记录
   * @param item
   */
  const delRecord = function ({ item }) {
    unref(item).check = false;
    selRecordByFalse(unref(item));
  };

  const getSelUsers = function () {
    return unref(alreadySelUsers);
  };

  const clearSelUsers=function (){
    alreadySelUsers.value=[];
  }

  return {
    clearSelUsers,
    delRecord,
    getSelUsers,
    multipleCount,
    selItemRecord,
    alreadySelUsers,
  };
}
